import { render, staticRenderFns } from "./manage-member.vue?vue&type=template&id=63c9da12&scoped=true"
import script from "./manage-member.vue?vue&type=script&lang=ts"
export * from "./manage-member.vue?vue&type=script&lang=ts"
import style0 from "./manage-member.vue?vue&type=style&index=0&id=63c9da12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c9da12",
  null
  
)

export default component.exports